import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getBlocked, blockWallet, unblockWallet, type BlockedListResponse } from '../api/walletBlocks';

export function useBlockedWallets() {
  const queryClient = useQueryClient();

  const {
    data,
    isPending: isLoading,
    error,
  } = useQuery<BlockedListResponse, Error>({
    queryKey: ['blockedWallets'],
    queryFn: () => getBlocked({ limit: 100 }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  const blockMutation = useMutation({
    mutationFn: blockWallet,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blockedWallets'] });
    },
  });

  const unblockMutation = useMutation({
    mutationFn: unblockWallet,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blockedWallets'] });
    },
  });

  return {
    blocked: data?.blocked ?? [],
    total: data?.pagination?.total ?? 0,
    isLoading,
    error,
    block: blockMutation.mutateAsync,
    unblock: unblockMutation.mutateAsync,
    isBlocking: blockMutation.isPending,
    isUnblocking: unblockMutation.isPending,
    blockError: blockMutation.error,
    unblockError: unblockMutation.error,
  };
}
